"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var category_1 = require("./data/category");
exports.MailOptions = category_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-options-mail/lib/index.js
// module id = 3378
// module chunks = 2